import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';
import { GoalType ,updateGoaltype,GoalTypeState } from './goaltypeTypes';


export const createGoaltype = createAsyncThunk(
    'performance/createGoaltype',
    async (data: GoalType, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.post('/performance/goaltype', data);          
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create Goaltype');
      }
    }
  ); 


  export const UpdateGoaltype = createAsyncThunk<any , {goaltypeId: number; data: any}, { rejectValue: string }>(
    'performance/updateGoaltype',
    async ({goaltypeId , data}: {goaltypeId : Number; data: Partial<updateGoaltype>}, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.put(`/performance/goaltype/${goaltypeId}`, data)
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create Goaltype');
      }
    }
  ); 


  export const deleteGoaltype = createAsyncThunk(
    'performance/deleteGoaltype',
    async (goaltypeId: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.delete(`/performance/goaltype/${goaltypeId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete Goaltype');
        }
    }
);

export const fetchGoalById = createAsyncThunk(
    'performance/fetchGoaltypeById',
    async (goaltypeId: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/performance/goaltype/${goaltypeId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch Goaltype');
        }
    }
);

export const fetchAllGoaltype = createAsyncThunk(
    'performance/fetchAllGoaltype',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/performance/goaltype');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Goaltype');
        }
    }
);